



























































import { Component, Vue } from 'vue-property-decorator'
import AuthService from '@/services/AuthService'

@Component({
  metaInfo: {
    meta: [
      {
        name: 'robots',
        content: 'noindex,nofollow,noarchive'
      }
    ]
  }
})
export default class ForgotPassword extends Vue {
  private email: string = ''
  private isLoading: boolean = false
  private sendMail: boolean = false
  private errorEmailMsg: string = ''

  sendToEmail() {
    let original_url = window.location.origin + '/forgot-password'
    let site_url = window.location.origin + '/reset-password'
    const data = {
      email: this.email,
      site_url: site_url,
      original_url: original_url
    }
    AuthService.forgotPassword(data)
      .then(res => {
        if (res.status === 200) {
          this.sendMail = true
          this.errorEmailMsg = ''
        }
      })
      .catch(error => {
        const errorKey = error.response.data.message
        // ERR_API_KEY (EMAIL_NOT_FOUND, MAIL_NOT_REGISTERED, MAIL_IN_TEMP_REGISTRATION, MAIL_PENDING_GROUP_ADMIN_APPROVAL)
        if (errorKey) {
          this.errorEmailMsg = `auth.forgot_password.${errorKey}`
        } else {
          this.errorEmailMsg = 'auth.forgot_password.error_email_msg'
        }
      })
  }

  resetMsg() {
    this.sendMail = false
    this.errorEmailMsg = ''
  }
}
